export function formatJson(value: string): string
export function formatJson(value: string | null): string | null
export function formatJson(value: string | null): string | null {
  if (!value) {
    return value
  }

  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value
  }
}
